import React from "react";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Compact inline select for list filters. Renders an "all" option using
 * `allLabel` mapped to an empty value.
 */
const FilterSelect = ({ value, onChange, options = [], allLabel }) => {
  const { t } = useTranslation();
  const active = Boolean(value);
  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`cursor-pointer appearance-none rounded-lg border py-2 pl-3 pr-8 text-sm outline-none transition-all duration-150 focus:border-[#E07A3A] focus:ring-2 focus:ring-[#E07A3A]/10 ${
          active
            ? "border-[#E07A3A] bg-[#FFF7ED] text-[#B45309]"
            : "border-[#E5E7EB] bg-white text-[#374151]"
        }`}
      >
        <option value="">
          {allLabel ?? t("admin.manufacturing.filters.all")}
        </option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown
        size={14}
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[#9CA3AF]"
      />
    </div>
  );
};

export default FilterSelect;

/**
 * Sort orders the wearables list offers, matching the backend's allow-list.
 * Empty value = the API default (newest first), so it renders as `allLabel`.
 * Unlabelled units sort last in both label directions, device-side.
 */
// Labels are translated at call time (not module load).
export const getWearableSortOptions = (t) => [
  { id: "field_label", label: t("admin.manufacturing.sort.labelAsc") },
  { id: "-field_label", label: t("admin.manufacturing.sort.labelDesc") },
  { id: "serial", label: t("admin.manufacturing.sort.serialAsc") },
  { id: "created_at", label: t("admin.manufacturing.sort.oldestFirst") },
];
